<template>
    <form @submit.prevent="submit">
        <button class="btn" :class="{'btn-alt-success': success, 'btn-alt-primary': ! success}" type="submit" :disabled="loading">
            {{ buttonText }}
        </button>

        <div v-if="commandError.length" class="mt-3 text-end">
            <span class="text-danger" v-text="commandError"></span>
        </div>
    </form>
</template>

<script setup>
import { ref } from "vue";
import { useFetch } from "@/components/useFetch";

const props = defineProps({
    route: String,
});

const defaultSubmitText = "Rerun";
const buttonText = ref(defaultSubmitText);
const loading = ref(false);
const success = ref(false);
const commandError = ref("");

const submit = async () => {
    commandError.value = "";
    success.value = false;
    loading.value = true;
    buttonText.value = "Submitting...";

    const response = await useFetch(
        props.route,
        {
            method: "POST",
            body: {
                //
            },
        },
    );

    if (response.ok) {
        success.value = true;
        buttonText.value = "Scheduled successfully";
        loading.value = false;
        return;
    }

    if (response.status === 422) {
        const data = await response.json();
        commandError.value = data?.errors?.command?.[0] ?? "";
    }

    buttonText.value = defaultSubmitText;
    loading.value = false;
};
</script>
